export default {"src":"/_next/static/media/doggo_error.a190166f.svg","height":375,"width":290};